<script>
	import { prefix, backBtn, mainStep, delayShort, delayMedium, startTime, i18n, language, stepQuestion, questions } from '../stores.js';
    import Button from '../Atoms/Button.svelte';
    import Icon from '../Atoms/Icon.svelte';
    import { onDestroy } from 'svelte';
	import { fade, scale, slide, fly } from 'svelte/transition';
	import { quartIn, quintIn } from 'svelte/easing';
    import { tick } from 'svelte';
    
    // $: currentQuestion = $questions && $questions[$mainStep] ? $questions[$mainStep] : '..';
    // let currentQuestion = $stepQuestion;
    let stepVisible = true; 

    async function selectAnswer(i) {
        let i18nNew = $i18n;
        try {
            i18nNew[$language].questions[$mainStep].answers[i].selected = !i18nNew[$language].questions[$mainStep].answers[i].selected;
            i18n.set(i18nNew); 
        } catch(e) {
            console.log("Error while setting answer: ", e);
        }
        await tick();
        if(!$stepQuestion.multiple) {
            nextStepTransition();
        }
	}

    async function deselectPrevious() {
        let i18nNew = $i18n;
        try {
            i18nNew[$language].questions[$mainStep-1].answers.forEach((a) => {
                a.selected = false;
            });
            i18n.set(i18nNew); 
        } catch(e) {
            console.log("Error while resetting ansers to previous question: ", e);
        }
        await tick();
	}



    function nextStep() {
        startTime.set( Date.now() );
        mainStep.set($mainStep + 1);
    }

    async function prevStep() {
        await deselectPrevious();
        startTime.set( Date.now() );
        mainStep.set($mainStep - 1 >= 0 ? $mainStep - 1 : 0);
    }    

    // const unsubscribe = stepQuestion.subscribe( newStepQuestion => {
    //     currentQuestion = newStepQuestion; 
    //     // await tick();  
    // });

    // onDestroy(() => {
	// 	// 4. We make sure to unsubscribe from the store once the component has been destroyed.
	// 	unsubscribe();
	// });

    function nextStepTransition() {
        stepVisible = false;
        nextStep();
        setTimeout( () => {
            stepVisible = true;
        }, $delayMedium);
    }

    function prevStepTransition() {
        stepVisible = false;
        prevStep();
        setTimeout( () => {
            stepVisible = true;
        }, $delayMedium);
    }


</script>

{#if stepVisible }
<!-- <div class="{$prefix}-question-container" in:fly="{{x:500, duration:$delayShort}}" out:fade="{{duration: $delayShort, easing: quartIn}}"> -->
<div class="{$prefix}-question-container" in:fade="{{duration: $delayShort, easing: quartIn}}" out:fly="{{y:300, duration:$delayShort}}">
    <div class="{$prefix}-question">
        {$stepQuestion.question}
    </div>
    <ul class="{$prefix}-answers">
        {#if $stepQuestion.answers }
            {#each $stepQuestion.answers as answer, i}
                <li class="{$prefix}-answer {answer.selected ? $prefix + '-answer--selected' : ''}  {$prefix}-answer--{$stepQuestion.answers.length}" on:click={ ()=>{ selectAnswer(i); } }>
                    <div class="{$prefix}-answer__select-icon">
                        <Icon iconName="check-plain" iconClass="fill" />
                    </div>
                    <img class="{$prefix}-answer__img {$prefix}-answer__img--{$stepQuestion.answers.length}" src="{answer['image_url']}" />
                    {#if answer['text_headline'] }
                        <h2 class="{$prefix}-answer__headline">{@html answer['text_headline'] }</h2>
                    {/if}
                    {#if answer.text }
                        <div class="{$prefix}-answer__text">{@html answer.text}</div>
                    {/if}
                    <!-- {#if !$stepQuestion.multiple } -->
                        <div class="{$prefix}-answer__icon">
                            <Icon iconName="arrow-right-small" iconClass="arrow-small" />
                        </div>      
                    <!-- {/if} -->
                </li>
            {/each}
        {/if}
    </ul>   
    {#if $stepQuestion && $stepQuestion.multiple }
        <div class="{$prefix}-question">
            <Button buttonText={$stepQuestion['next_step']} buttonClass="{$stepQuestion.answers.filter((a) => {return a.selected === true;}).length < 1 ? 'cta-disabled' : 'cta'}" on:buttonClicked={()=>nextStepTransition()} />
        </div>    
    {/if}
    {#if  $mainStep > 0}
        <center>
            <div class="{$prefix}-back" on:click={()=>prevStepTransition()}>
                <Icon iconName="arrow-left-small" iconClass="arrow-left-small" />
                <span class="{$prefix}-back__text">{$backBtn}</span>
            </div>    
        </center>
    {/if}
</div>
{/if}

<style type="text/scss">
    @import './sass/vars';

    .#{$prefix}-question { 
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        text-align: center;
        font-size: 36px;
        margin: 3rem 1rem 0;
        @media only screen and (max-width: $breakpoint-medium) {
            margin: 3rem 1rem 0rem;
            font-size: 24px;
            margin-bottom: 0;
        }

        &-container {
            @media only screen and (min-width: $breakpoint-medium) {
                height: 550px;
            }
        }
    }

    .#{$prefix}-answers { 
        list-style: none;
        display: flex;
        padding: 0;
        justify-content: center;
        flex-flow: row nowrap;
        margin: 2rem 1rem 1rem;
        @media only screen and (max-width: $breakpoint-medium) {
            margin-top: 0;
            flex-flow: column nowrap;
            margin: 2rem 1rem 1rem;
        }
    }

    .#{$prefix}-answer { 
        padding: $default-padding;
        cursor: pointer;
        display: flex;
        flex-flow: column wrap;
        align-items: center;
        justify-content: flex-start;
        position: relative;
        border: solid 4px #ffffff;
        border-radius: $border-radius;
        box-shadow: $drop-shadow-box;
        position: relative;


        @media only screen and (min-width: $breakpoint-medium) {
            min-height: 240px;
            margin-left: $default-margin*2;
            max-width: 25%;
            justify-content: space-between;
            &:first-of-type {
                margin-left: 0;
            }


            // .#{$prefix}-answer__img {
            //     &--2 {
            //         padding: 2.5rem;
            //     }

            // }

        }


        @media only screen and (min-width: $breakpoint-large) {
            width: 25%;
            min-height: 385px;
            .#{$prefix}-answer__img {
                height: 190px;
                width: 170px;
            }

        }


        @media only screen and (max-width: $breakpoint-medium) {
            display: flex;
            flex-flow: row nowrap;
            margin-bottom: 1.5rem;
            padding: 1rem;
        }

       &--selected, &:hover, &:active {
            border: solid 4px $primary; 
            &::before{
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                opacity: 0.1;
                background-color: $primary;
            }
        }

        &__select-icon {
            position: absolute;
            width: 2.25rem;
            height: 2.25rem;
            top: $default-padding;
            right: $default-padding;
            padding: 0.5rem;
            background-color: $primary;
            border-radius: 50%;
            opacity: 0;
            transition: all 0.3s;
            z-index: 2;

            @media only screen and (max-width: $breakpoint-medium) {
                top: calc(50% - 20px;
                right: 1rem;
            }
        }
        &__img {
            margin-bottom: 1rem;
            padding: 1.5rem;
            @media only screen and (max-width: $breakpoint-medium) {
                width: 4rem;
                margin-bottom: 0;
                padding: 0.5rem;
            }
        }

        &__headline {
            font-size: 3rem;
            margin: 0.75rem 0;

            @media only screen and (max-width: $breakpoint-medium) {
                font-size: 1rem;
                font-weight: bold;
                margin-left: 0.75rem;
            }

        }
        &__text {

            font-size: 1rem;
            text-align: center;
            @media only screen and (max-width: $breakpoint-medium) {
                flex-grow: 1;
                font-size: 0.825rem;
                line-height: 1.5;
                margin-left: 0.5rem;
            }

            @media only screen and (min-width: $breakpoint-large) {
                margin-top: auto;
            }

        }

        &__icon {
            @media only screen and (max-width: $breakpoint-medium) {
                margin-left: auto;
            }
        }

        &--selected {
            .#{$prefix}-answer__select-icon {
                opacity: 1; 
            }
        }

    }

    .#{$prefix}-back { 
        width: auto;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        padding: 2rem;
        cursor: pointer;
        /* &:hover {
            border-bottom: solid 1px;
        } */
        &__text {
            line-height: 16px;
            margin-left: 0.5rem;
            font-size: 14px;
        }

        @media only screen and (max-width: $breakpoint-medium) {
            padding: 1rem;
            margin-bottom: 1rem;
        }

    }

</style>